<template>
  <div>
    <section id="SingleGameSuites">
      <b-container>
        <b-row>
          <b-col>
            <h1>Single Game Suites</h1>
            <div class="line"></div>
          </b-col>
        </b-row>
        <b-row v-if="selectedArea">
          <b-col lg="6" md="12" class="left">
            <div class="right">
              <div class="image">
                <img :src="selectedArea.imgSrc" :alt="selectedArea.imgAlt" />
              </div>
              <div class="buttons">
                <button
                  class="btn btn-secondary"
                  :class="{ 'selected-button': selectedArea.id === area.id }"
                  v-for="area in singleGameSuitesSections"
                  :key="area.buttonText"
                  @click="btnClickHandler(area.id)"
                >
                  {{ area.buttonText }}
                </button>
              </div>
              <div>
                <p class="text">
                  {{ selectedArea.info }}
                </p>
                <ul>
                  <li
                    v-for="bulletPoint in selectedArea.bullets"
                    :key="'suite-' + bulletPoint"
                    v-html="bulletPoint"
                  ></li>
                </ul>
                <div class="buy-now">
                  <a
                    href="https://www.mlb.com/rays/tickets/premium/suites"
                    target="_blank"
                  >
                    <button class="btn btn-secondary">Buy Now</button></a
                  >
                </div>
              </div>
            </div>
          </b-col>
          <b-col lg="6" md="12">
            <div class="right">
              <img
                class="center-map"
                :src="selectedArea.mapSrc"
                :alt="selectedArea.mapAlt"
              />
              <div class="legal-text">
                <p>
                  For the 2024 season, all suites at Tropicana Field include
                  catering to complete your event!
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <Banner bannerDivider="seventh" />
  </div>
</template>

<script>
import { singleGameSuitesData } from "@/data/singleGameSuitesData";
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "SingleGameSuites",
  components: { Banner },
  data() {
    return {
      selectedId: "",
    };
  },
  methods: {
    btnClickHandler(id) {
      this.selectedId = id;
    },
  },
  computed: {
    selectedArea() {
      return this.singleGameSuitesSections.find(
        (area) => area.id === this.selectedId
      );
    },
    singleGameSuitesSections() {
      return this.$store.getters.getSubSectionsByParent("9").map((s) => {
        return { ...s, ...singleGameSuitesData.find((p) => p.id === s.id) };
      });
    },
  },
  mounted() {
    this.selectedId = this.singleGameSuitesSections?.[0]?.id;
  },
};
</script>


<style lang="scss" scoped>
#SingleGameSuites {
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/bgImage_babyblue.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .center-map {
    margin: 40px auto 0;
  }
  .line {
    background-color: $yellow;
    width: 374px;
    height: 5px;
    margin: 15px 0 1em;
    @media only screen and (max-width: $md) {
      width: 80%;
    }
  }
  h1 {
    font-family: "Antique Olive";
    font-style: normal;
    font-weight: 700;
    font-size: 35px;
    line-height: 80%;
    text-transform: uppercase;
    color: #00285e;
    @media only screen and (max-width: $sm) {
      font-size: 25px;
    }
  }
  .buttons {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    gap: 10px;
    margin-block: 5px;
    width: 100%;
    @media only screen and (max-width: $sm) {
      flex-direction: column;
      width: 100%;
    }
    button {
      @media only screen and (max-width: $sm) {
        width: 100%;
      }
      min-width: calc(50% - 5px);
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      text-transform: uppercase;
      color: #00285e;
      border: 2px solid #00285e;
      border-radius: 50px;
      padding: 10px 17px;
      background: transparent;
      &.selected-button {
        color: #00285e;
        border-color: $yellow;
      }
    }
  }
  .legal-text {
    font-family: "Futura";
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    align-items: center;
    color: #00285e;
    margin-top: auto;
    padding-block: 40px;
  }
  .left {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: stretch;
  }
  .image {
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      width: calc(100% + 100px);
      max-width: unset;
    }
  }
  .right {
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 145%;
    color: #00285e;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    gap: 20px;
    .text {
      margin-block: 10px !important;
    }
    .logo {
      margin-block: 20px;
      background: white;
      padding: 1em;
    }
  }
  .buy-now {
    text-align: center;
    button {
      width: 400px;
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-transform: uppercase;
      color: #00285e;
      border: 2px solid $yellow;
      border-radius: 50px;
      padding: 10px 40px;
      background: $yellow;
    }
  }
}
</style>
